import { DEFAULT_LANGUAGE } from '../../i18n/i18n';

const buildSupportReason = (reason, lang) => (
    lang && lang !== DEFAULT_LANGUAGE ? `${reason} - ${lang.toUpperCase()}` : reason
);

export {
    buildSupportReason
};
